import { Box, Center, Flex, Image } from "@chakra-ui/react";
import React from "react";
import CustomText from "./CustomText";
import CustomHeading from "./CustomHeading";
import tokenomicImg from "../assets/images/tokenomic_center.svg";
import treasury from "../assets/images/treasury.svg";
import ip from "../assets/images/lp.svg";
import presale from "../assets/images/presale.svg";
import tokenomicEnd from "../assets/images/tokenomic_end.svg";
import dexCex from "../assets/images/dex-cex.svg";

const Tokenomics = () => {
  return (
    <section id="tokenomics">
      <Center
        bg={"#FFFAFF"}
        position={"relative"}
        mt={"-40px"}
        py={"100px"}
        flexDir={"column"}
        px="20px"
      >
        <CustomHeading
          text="Tokenomics"
          size={{ base: "36px", lg: "64px" }}
          color="#191919"
          family="bryndan-write"
        />
        <Box
          mb={{ base: "120px", lg: "240px" }}
          mt={{ base: "90px", lg: "180px" }}
          pos="relative"
        >
          <Image
            src={treasury}
            alt="treasury Img"
            w={{ base: "150px", lg: "500px" }}
            pos="absolute"
            left="0"
            ml={{ base: "-80px", lg: "-220px" }}
            top="0"
            mt={{ base: "10px", lg: "-90px" }}
          />
          <Image
            src={ip}
            alt="lp"
            w={{ base: "150px", lg: "500px" }}
            pos="absolute"
            right="0"
            mr={{ base: "-80px", lg: "-220px" }}
            top="0"
            mt={{ base: "10px", lg: "-90px" }}
          />
          <Flex justify={"center"} align={"center"}>
            <Image
              src={tokenomicImg}
              alt="tokenomic Img"
              w={{ base: "280px", lg: "330px" }}
            />
          </Flex>
          <Image
            src={presale}
            alt="presale"
            w={{ base: "150px", lg: "500px" }}
            pos="absolute"
            bottom="0"
            left="0"
            ml={{ base: "-70px", lg: "-200px" }}
            mb={{ base: "-20px", lg: "-150px" }}
          />
          <Image
            src={dexCex}
            alt="dexCex"
            mt={{ lg: "-35px" }}
            w={{ base: "150px", lg: "500px" }}
            pos="absolute"
            bottom="0"
            right="0"
            mr={{ base: "-70px", lg: "-200px" }}
            mb={{ base: "-20px", lg: "-150px" }}
          />
        </Box>
        <CustomText
          text="TOKEN SUPPLY 600,000,001"
          size={{ base: "24px", lg: "48px" }}
          height={{ base: "33px", lg: "54.62px" }}
          color="#191919"
        />
        <CustomText
          text="(Approximately the population of cats in the world)"
          size={{ base: "18px", lg: "36px" }}
          color="#191919"
          align="center"
        />
        <Flex
          w={"360px"}
          justify={"center"}
          flexDir="column"
          mt={{ base: "24px", lg: "65px" }}
          gap="10px"
        >
          <CustomText
            text="-Learn More"
            size={{ base: "18px", lg: "36px" }}
            color="#191919"
            decoration="underline"
          />
          <CustomText
            text="-LP Locked 365 Days"
            size={{ base: "18px", lg: "36px" }}
            color="#191919"
            decoration="underline"
          />
        </Flex>
        <Flex mt={{ base: "24px", lg: "65px" }}>
          <Image src={tokenomicEnd} alt="icons" />
        </Flex>
      </Center>
    </section>
  );
};

export default Tokenomics;
